import React from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '../../../components/ui/input';
import { Search, Filter } from 'lucide-react';

interface MembersFiltersProps {
    searchTerm: string;
    onSearchChange: (term: string) => void;
    filterRole: string;
    onRoleChange: (role: string) => void;
    totalMembers: number;
}

export const MembersFilters: React.FC<MembersFiltersProps> = ({
    searchTerm, onSearchChange, filterRole, onRoleChange, totalMembers
}) => {
    const { t } = useTranslation('common');

    return (
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-200 mb-6 flex flex-col md:flex-row gap-4 justify-between items-center">
            <div className="relative w-full md:w-96">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <Input
                    type="text"
                    placeholder={t('members.filters.search')}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="pl-10"
                />
            </div>

            <div className="flex items-center gap-4 w-full md:w-auto">
                <div className="flex items-center gap-2">
                    <Filter size={16} className="text-gray-500" />
                    <span className="text-sm font-medium text-gray-700 whitespace-nowrap">{t('members.filters.role')}:</span>
                    <select
                        value={filterRole}
                        onChange={(e) => onRoleChange(e.target.value)}
                        className="h-10 px-3 py-2 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                        <option value="all">{t('members.filters.all')}</option>
                        <option value="student">{t('members.filters.student')}</option>
                        <option value="instructor">{t('members.filters.instructor')}</option>
                        <option value="admin">{t('members.filters.admin')}</option>
                    </select>
                </div>

                <div className="hidden md:block w-[1px] h-8 bg-gray-200 mx-2"></div>

                <div className="text-sm text-gray-500 whitespace-nowrap">
                    <strong>{totalMembers}</strong> {t('members.stats.total')}
                </div>
            </div>
        </div>
    );
};
